import { ArrowDown, BookOpen, Sparkles } from "lucide-react";
import { assetUrl } from "@/lib/assets";

export default function Doctrinal() {
  return (
    <section id="doctrinalhero" data-nav="dark" className="acad-beliefs-hero">
      <img
        className="acad-beliefs-hero-image"
        src={assetUrl("WhatsApp-Image-2026-08-21-at-9.11.01-AM.jpeg")}
        alt="Congregación de las Asambleas de Dios adorando y afirmando su fe"
        loading="eager"
        decoding="async"
      />
      <span className="acad-beliefs-hero-overlay" />
      <span className="acad-beliefs-hero-grid" aria-hidden="true" />

      <div className="acad-beliefs-shell acad-beliefs-hero-inner">
        <div className="acad-beliefs-hero-topline">
          <span><BookOpen aria-hidden="true" /> ACAD Costa Rica</span>
          <span>Declaración doctrinal oficial</span>
        </div>

        <div className="acad-beliefs-hero-copy">
          <span className="acad-beliefs-eyebrow acad-beliefs-eyebrow--light">
            <Sparkles aria-hidden="true" /> Una fe profundamente bíblica
          </span>
          <h1>Creemos.</h1>
          <p>
            Dieciséis verdades fundamentales que expresan nuestra fe, orientan
            nuestra vida y sostienen nuestra misión.
          </p>
        </div>

        <div className="acad-beliefs-hero-bottom">
          <a href="#doctrinalcatalog">
            Explorar las verdades <i><ArrowDown aria-hidden="true" /></i>
          </a>
          <div className="acad-beliefs-hero-count">
            <strong>16</strong>
            <span>Verdades<br />fundamentales</span>
          </div>
        </div>
      </div>

      <span className="acad-beliefs-outline-word" aria-hidden="true">FE</span>
    </section>
  );
}
